import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  & .icon {
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
`

Wrapper.displayName = 'Wrapper'

export const styles = css`
  input#date-picker-input-fake:not([disabled]) {
    background-color: transparent !important;
    border: 1px solid var(--gray-200) !important;
  }
`

export const datePickerModal = css`
  #date-picker-modal {
    background-color: var(--gray-100) !important;
  }

  .hot-form__input {
    border: 1px solid var(--gray-200) !important;
    background-color: transparent !important;
  }

  .hot-button {
    background-color: inherit !important;
    color: var(--gray-500) !important;
  }

  .hot-button.hot-button--primary {
    color: var(--gray-500) !important;
  }

  .flatpickr-disabled {
    color: var(--gray-500) !important;
  }
`
